export default __webpack_public_path__ + "static/media/logo.a22892eb.svg";